import React, { useState } from 'react';
import { FDHeadlineText, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import {
  ActionPaper,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/Content/ActionsSection/ActionPaper';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { followRelationship } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useEventTrackingLogEvent, { categories, eventTypes, eventSubTypes } from 'EventTracking/useEventTrackingLogEvent';
import { maxWidthForActionsSection } from './ActionsSection/consts';

const overrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'lg' },
  }, overrideReadOnly);

export const ModelUpdatesSection = ({ sectionResource }) => {
  const [completing, setCompleting] = useState(false);
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent({
    nodeName: 'PM2 model updates',
  });

  const markComplete = async () => {
    setCompleting(true);
    try {
      await followRelationship(sectionResource.relationship(fr.relationships.markComplete.name));
      await refreshPageContentCollection();
      logStandardizedEvent(categories.pm1OrPM2, eventTypes.confirmModelUpdates, eventSubTypes.success);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    } finally {
      setCompleting(false);
    }
  };
  return (
    <FDStack width={'100%'} maxWidth={maxWidthForActionsSection}>
      <ActionPaper completed={sectionResource.isTruthy('completed')}>
        <FDStack direction="column" spacing={3}>
          <MetaControl resource={sectionResource} attrName="title" metaOverrideSet={overrides} />
          <MetaControl resource={sectionResource} attrName="description" metaOverrideSet={overrides} />
          <FDStack spacing={3} wrap>
            <SecondaryActionButtonRel relationship={sectionResource.relationship(fr.relationships.learnMore.name)} />
            <FDStack flex={1}>
              <PrimaryActionButtonRel
                relationship={sectionResource.relationship(fr.relationships.markComplete.name)}
                isFullWidth
                loading={completing}
                overrideOnClick={markComplete}
              />
            </FDStack>
          </FDStack>
        </FDStack>
      </ActionPaper>
    </FDStack>
  );
};
